<template>
  <div>
    <template v-if="isProfileIndex">
      <div
        :class="[
          'mb-20',
          {
            'mb-sm-30 mb-lg-40': !deviceType.isMobile,
          },
        ]"
      >
        <PageTitle :title="$t('components.tabbar.profile')" :bordered="true" />
      </div>
      <div>
        <template v-if="showReferral">
          <div
            :class="[
              'px-20 mb-20',
              {
                'px-md-30 mb-sm-30 mb-lg-40': !deviceType.isMobile,
              },
            ]"
          >
            <div class="new-container mx-auto">
              <div
                :class="[
                  'mb-20',
                  {
                    'mb-md-30': !deviceType.isMobile,
                  },
                ]"
              >
                <ReferralBanner />
              </div>
            </div>
          </div>
        </template>
        <div
          :class="[
            'px-20 mb-20',
            {
              'px-md-30 mb-sm-30 mb-lg-40': !deviceType.isMobile,
            },
          ]"
        >
          <div class="new-container mx-auto">
            <Station
              :list="allMenu"
              @onClickChangeLanguage="onClickChangeLanguage"
              @onClickChangeCurrency="onClickChangeCurrency"
              @onClickLogout="onClickLogout()"
            />
          </div>
        </div>
        <client-only>
          <LanguagesModal
            :modal-view="languagesModalView"
            :languages="languages"
            :title="$t('components.languages.modal.title')"
            :search-input-placeholder="$t('placeholder.languages.modal.language')"
            :empty-text="$t('global.no-language-available')"
            @onCloseLanguagesModal="onCloseLanguagesModal"
          />
          <CurrenciesModal
            :modal-view="currenciesModalView"
            :currencies="currencies"
            :title="$t('components.currencies.modal.title')"
            :search-input-placeholder="$t('placeholder.currencies.modal.currency')"
            :empty-text="$t('global.no-currency-available')"
            @onCloseCurrenciesModal="onCloseCurrenciesModal"
          />
        </client-only>
      </div>
    </template>
    <template v-else-if="isProfileOutter">
      <div>
        <nuxt-child :show-referral="showReferral" />
      </div>
    </template>
    <template v-else>
      <div>
        <template v-if="isLoggedIn">
          <div
            :class="[
              'mb-20',
              {
                'mb-sm-30 mb-lg-40': !deviceType.isMobile,
              },
            ]"
          >
            <div :class="['display-none', { 'display-lg-block': !deviceType.isMobile }]">
              <PageTitle :title="$t('components.tabbar.profile')" :bordered="!isShowTopTabs" />
            </div>

            <template v-if="isShowTopTabs">
              <div class="tw-bg-white tw-border-0 tw-border-b tw-border-solid tw-border-[#ddd]">
                <tabs :tabs="topTabs" />
              </div>
            </template>

            <div v-if="getMobileKey()" :class="['display-block', { 'display-lg-none': !deviceType.isMobile }]">
              <PageTitle
                :title="$t(getMobileKey().key)"
                :bordered="true"
                :back-button="{
                  url: getMobileKey().backRoute,
                  hiddenAfterSizes: 'sm',
                }"
              />
            </div>
          </div>
          <div
            :class="[
              'px-0 mb-20',
              {
                'px-lg-30 mb-sm-30 mb-lg-40': !deviceType.isMobile,
              },
            ]"
          >
            <div class="new-container mx-auto">
              <template v-if="!isProfileIndex">
                <div
                  :class="[
                    'px-20',
                    {
                      'px-md-30 px-lg-0': !deviceType.isMobile,
                    },
                  ]"
                >
                  <Breadcrumb :breadcrumbs="breadcrumbList" />
                </div>
              </template>
              <div
                :class="[
                  'd-grid grid-cols-6 gap-30',
                  {
                    'grid-cols-md-12': !deviceType.isMobile,
                  },
                ]"
              >
                <div
                  :class="[
                    'display-none',
                    {
                      'display-lg-flex col-span-lg-4': !deviceType.isMobile,
                    },
                  ]"
                >
                  <div class="w-full">
                    <LeftMenu :for-user="true" :user-name="userName" :user-badge="userBadgeData" :list="leftMenu" />
                  </div>
                </div>
                <div
                  :class="[
                    'col-span-6',
                    {
                      'col-span-md-12 col-span-lg-7 col-start-lg-6': !deviceType.isMobile,
                    },
                  ]"
                >
                  <template
                    v-if="
                      routeBaseName === 'profile-index-change-email' ||
                      routeBaseName === 'profile-index-change-password'
                    "
                  >
                    <template v-if="userInfoData">
                      <nuxt-child :user-info="userInfoData" />
                    </template>
                  </template>
                  <template v-else>
                    <nuxt-child :show-referral="showReferral" />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import PageTitle from '~/components/shared/page-title.vue'
  import Station from '~/components/shared/station.vue'
  import ReferralBanner from '~/components/banners/referral.vue'
  import LanguagesModal from '~/components/modals/languages-modal.vue'
  import LeftMenu from '~/components/menus/left.vue'
  import Breadcrumb from '~/components/shared/breadcrumb'
  import Tabs from '~/components/tabs/route-switcher-tabs.vue'
  import CurrenciesModal from '~/components/modals/currencies-modal.vue'

  export default {
    components: {
      CurrenciesModal,
      PageTitle,
      Station,
      ReferralBanner,
      LanguagesModal,
      LeftMenu,
      Breadcrumb,
      Tabs,
    },

    middleware: 'guest',

    data() {
      return {
        profileTitles: [
          {
            routeName: 'profile-index-settings',
            key: 'scenes.profile.account-information',
            backRoute: 'profile',
          },
          {
            routeName: 'profile-index-settings-index-change-email',
            key: 'scenes.profile.account-information',
            backRoute: 'profile-index-settings',
          },
          {
            routeName: 'profile-index-settings-index-change-password',
            key: 'scenes.profile.account-information',
            backRoute: 'profile-index-settings',
          },
          {
            routeName: 'profile-index-settings-delete-account-success',
            key: 'scenes.account.information.delete-account-title',
            backRoute: 'profile-index-settings',
          },
          {
            routeName: 'profile-index-identity-authentication',
            key: 'scenes.profile.identity-authentication',
            backRoute: 'profile',
          },
          {
            routeName: 'profile-index-airmoney',
            key: 'scenes.profile.airmoney-loyalty-status',
            backRoute: 'profile',
          },
          {
            routeName: 'profile-index-credit-cards',
            key: 'scenes.profile.saved-cards',
            backRoute: 'profile',
          },
          {
            routeName: 'profile-index-referral',
            key: 'scenes.referral.navigation-title',
            backRoute: 'profile',
          },
          {
            routeName: 'profile-index-orders',
            key: 'scenes.profile.orders',
            backRoute: 'profile',
          },
          {
            routeName: 'profile-index-orders-id',
            key: 'scenes.order.detail.navigation-title',
            backRoute: 'profile-index-orders',
          },
          {
            routeName: 'profile-index-organizations',
            key: 'scenes.profile.organizations',
            backRoute: 'profile',
          },
        ],
        userMenu: [
          {
            key: 'components.main.navigation.account-information',
            route: {
              name: 'profile-index-settings',
            },
          },
          {
            key: 'components.main.navigation.airmoney-loyalty-status',
            route: {
              name: 'profile-index-airmoney',
            },
          },
          {
            key: 'components.main.navigation.saved-cards',
            route: {
              name: 'profile-index-credit-cards',
            },
          },
          {
            key: 'components.main.navigation.referral',
            route: {
              name: 'profile-index-referral',
            },
          },
          {
            key: 'components.main.navigation.orders',
            route: {
              name: 'profile-index-orders',
            },
          },
          {
            key: 'components.main.navigation.logout',
            emit: 'onClickLogout',
            isHideDesktop: true,
            isLogOut: true,
          },
        ],
        otherMenu: [
          {
            key: 'scenes.profile.language',
            keyParameters: {
              language: this.$i18n.currentLanguageName(),
            },
            emit: 'onClickChangeLanguage',
          },
          {
            key: 'scenes.profile.currency',
            keyParameters: {
              currency: this.$store.getters['multiCurrency/get_current_currency_title'],
            },
            emit: 'onClickChangeCurrency',
          },
          {
            key: 'components.sub.navigation.help-center',
            route: '/help',
            isExternalRoute: true,
          },
          {
            key: 'components.sub.navigation.blog',
            route: {
              name: 'blog',
            },
          },
          {
            key: 'components.sub.navigation.referral',
            route: {
              name: 'referral',
            },
          },
          {
            key: 'components.sub.navigation.partners',
            route: {
              name: 'partner-with-us',
            },
          },
          {
            key: 'components.sub.navigation.about-us',
            route: {
              name: 'about-us',
            },
          },
          {
            key: 'components.sub.navigation.title',
            route: {
              name: 'more-info',
            },
          },
        ].map((item) => this.$utils.getShortLocalesCodeForHelp(item, null)),
        allBreadcrumbList: [
          {
            key: 'profile-index',
            title: this.$t('components.breadcrumb.profile'),
            link: 'profile',
          },
          {
            key: 'settings',
            title: this.$t('components.breadcrumb.account-information'),
            link: 'profile-index-settings',
          },
          {
            key: 'index-change-email',
            title: this.$t('components.breadcrumb.change-email'),
            link: 'profile-index-settings-index-change-email',
          },
          {
            key: 'index-change-password',
            title: this.$t('components.breadcrumb.change-password'),
            link: 'profile-index-settings-index-change-password',
          },
          {
            key: 'identity-authentication',
            title: this.$t('components.breadcrumb.identity-authentication'),
            link: 'profile-index-identity-authentication',
          },
          {
            key: 'airmoney',
            title: this.$t('components.breadcrumb.airmoney-loyalty-status'),
            link: 'profile-index-airmoney',
          },
          {
            key: 'credit-cards',
            title: this.$t('components.breadcrumb.credit-cards'),
            link: 'profile-index-credit-cards',
          },
          {
            key: 'referral',
            title: this.$t('components.breadcrumb.refer-earn'),
            link: 'profile-index-referral',
          },
          {
            key: 'orders',
            title: this.$t('components.breadcrumb.orders'),
            link: 'profile-index-orders',
          },
          {
            key: 'orders-id',
            title: this.$t('components.breadcrumb.order-detail'),
            link: 'profile-index-orders-id',
          },
          {
            key: 'organizations',
            title: this.$t('components.breadcrumb.organizations'),
            link: 'profile-index-organizations',
          },
        ],
        showReferral: false,
        isLoggingOut: false,
        currenciesModalView: false,
        languagesModalView: false,
        topTabs: [
          {
            text: this.$t('scenes.identity.verification.default-tab'),
            route: {
              name: 'profile-index-identity-authentication-default',
            },
          },
          {
            text: this.$t('scenes.identity.verification.one-time-tab'),
            route: {
              name: 'profile-index-identity-authentication-onetime',
            },
          },
        ],
      }
    },

    computed: {
      ...mapGetters({
        isCoBranded: 'coBranding/getIsCoBranded',
      }),

      currencies() {
        return this.$store.getters['multiCurrency/get_available_currencies']
      },
      deviceType() {
        return this.$store.getters.get_device_types
      },
      userIdentitiesDefault: {
        get() {
          const userIdentitiesDefault = this.$store.getters['eKyc/get_user_default_identities']
          if (userIdentitiesDefault && !!Object.keys(userIdentitiesDefault).length) {
            this.$store.dispatch('eKyc/fetch_user_identities')
          }
          return userIdentitiesDefault
        },
      },
      userIdentities: {
        get() {
          return this.$store.getters['eKyc/get_user_identities']
        },
      },
      isShowTopTabs() {
        return (
          this.userIdentities?.some((item) => item.is_kyc_one_time) &&
          this.getRouteBaseName().includes('profile-index-identity-authentication')
        )
      },
      routeBaseName() {
        return this.getRouteBaseName() ? this.getRouteBaseName() : 'profile'
      },
      isProfileIndex() {
        return this.routeBaseName === 'profile' || this.routeBaseName === 'profile-index'
      },
      isProfileOutter() {
        return this.routeBaseName === 'profile-index-settings-delete-account-success'
      },
      isLoggedIn() {
        return this.$auth.loggedIn
      },
      userName() {
        return this.isLoggedIn ? this.$auth.$state.user.name : null
      },
      userBadgeData() {
        return this.isLoggedIn ? this.$auth.$state.user.ranking : null
      },
      userInfoData() {
        return this.isLoggedIn ? { ...this.$store.$auth.$state.user } : null
      },
      allMenu() {
        const isLoggedIn = this.isLoggedIn
        if (isLoggedIn && !this.userIdentitiesDefault) {
          this.userMenu = this.userMenu.filter((v) => v.key !== 'components.main.navigation.identity-authentication')
        }
        if (isLoggedIn && this.userIdentitiesDefault) {
          const IDVerificationItem = this.userMenu.find(
            (v) => v.key === 'components.main.navigation.identity-authentication'
          )

          if (!IDVerificationItem) {
            this.userMenu = this.userMenu.filter((v) => v.key !== 'components.main.navigation.identity-authentication')
            this.userMenu.splice(1, 0, {
              key: 'components.main.navigation.identity-authentication',
              route: {
                name: 'profile-index-identity-authentication-default',
              },
            })
          }
        }

        if (this.isCoBranded) {
          this.otherMenu = this.otherMenu.filter((v) => v.key !== 'components.sub.navigation.partners')
        }

        return isLoggedIn
          ? [
              {
                key: this.userName,
                isUserName: true,
                isHideDesktop: true,
                group: 'first',
                badgeData: this.userBadgeData,
              },
              ...this.userMenu.map((v) => ({ ...v, group: 'first' })),
              ...this.otherMenu.map((v) => ({ ...v, group: 'second' })),
            ]
          : [
              {
                key: 'components.main.navigation.login-register',
                route: {
                  name: 'auth-index-login',
                },
                isUserLogin: true,
                isHideDesktop: true,
                group: 'first',
              },
              ...this.otherMenu.map((v) => ({ ...v, group: 'second' })),
            ]
      },
      leftMenu() {
        const isLoggedIn = this.isLoggedIn

        if (isLoggedIn) {
          if (this.userIdentitiesDefault) {
            const IDVerificationItem = this.userMenu.find(
              (v) => v.key === 'components.main.navigation.identity-authentication'
            )

            if (!IDVerificationItem) {
              this.userMenu.splice(1, 0, {
                key: 'components.main.navigation.identity-authentication',
                route: {
                  name: 'profile-index-identity-authentication-default',
                },
              })
            }
          } else {
            this.userMenu = this.userMenu.filter((v) => v.key !== 'components.main.navigation.identity-authentication')
          }
        }
        return this.userMenu
      },
      languages() {
        return this.$i18n.locales
      },
      isLogoutModalShown: {
        get() {
          return this.$store.getters.get_logout_modal_visibility
        },
        set(value) {
          this.$store.commit('set_logout_modal_visibility', value)
        },
      },
      breadcrumbList() {
        const routeBase = this.routeBaseName
        let list = this.allBreadcrumbList.filter((v) => routeBase.includes(v.key))

        if (routeBase === 'profile-index-change-email' || routeBase === 'profile-index-change-password') {
          const settingsItem = this.allBreadcrumbList.find((v) => v.key === 'settings')
          list.splice(1, 0, settingsItem)
        }
        return list
      },
    },

    methods: {
      async readRemoteConfig() {
        try {
          this.showReferral =
            this.$store.state.auth.user &&
            this.$store.state.auth.user.referral &&
            this.$store.state.auth.user.referral.show_banner
        } catch (e) {
          this.showReferral = false
          return
        }
      },
      onClickChangeCurrency() {
        this.currenciesModalView = true
      },
      onClickChangeLanguage() {
        this.languagesModalView = true
      },
      onClickLogout() {
        this.$store.commit('set_logout_modal_visibility', true)
      },
      onCloseCurrenciesModal() {
        this.currenciesModalView = false
      },
      onCloseLanguagesModal() {
        this.languagesModalView = false
      },
      getMobileKey() {
        return this.profileTitles.find((v) => v.routeName === this.getRouteBaseName())
      },
    },

    created() {
      if (this.$featureFlag.isActive('enable_corporate_mode')) {
        this.userMenu.splice(-1, 0, {
          key: 'components.main.navigation.organizations',
          route: {
            name: 'profile-index-organizations',
          },
        })
      }
    },

    async mounted() {
      if (this.$auth.loggedIn) {
        await this.readRemoteConfig()
      }
    },

    scrollToTop: true,
  }
</script>
